import React from 'react';
import { NavLink } from 'react-router-dom';
import Header2 from '../Common/Header2';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';

const filters = [
    { label: "International Safety Week ", filter: ".cat-1" },
    { label: "Holi Celebration", filter: ".cat-2" },
    // { label: "Outdoor", filter: ".cat-3" },
    // { label: "Interiors", filter: ".cat-4" },
    // { label: "Residential", filter: ".cat-5" }
];

const GalleryImages = [
    {
        image: require('./../../images/gallery/saftyweek/sw1.jpg'),
        //title: 'Interior Work Avroko',
        //address: 'Muscat, Sultanate of Oman',
        filter: 'cat-1'
    },
    {
        image: require('./../../images/gallery/saftyweek/sw2.jpg'),
        //title: 'Interior Work Avroko',
        //address: 'Muscat, Sultanate of Oman',
        filter: 'cat-1'
    },
    {
        image: require('./../../images/gallery/saftyweek/sw3.jpg'),
        //title: 'Interior Work Avroko',
        //address: 'Muscat, Sultanate of Oman',
        filter: 'cat-1'
    },
    {
        image: require('./../../images/gallery/saftyweek/sw4.jpg'),
        //title: 'Interior Work Avroko',
        //address: 'Muscat, Sultanate of Oman',
        filter: 'cat-1'
    }
]

var bnrimg = require('./../../images/banner/5.jpg');
// var bgimg1 = require('./../../images/background/cross-line.png');

class Gallery extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };
        loadScript('./assets/js/custom.js');


    };
    render() {
        return (
            <>
                <Header2 />
                <div className="page-content">
                    <Banner title="Gallery" pagename="Gallery Page" description="" bgimage={bnrimg}/>
                    
                    <div className="section-full p-tb80 column-grid-4 inner-page-padding">
                        <div className="container">
                            <div className="filter-wrap p-b30 text-center">
                                <ul className="filter-navigation masonry-filter clearfix">
                                    <li className="active"><NavLink to={"#"} className="btn from-top" data-filter="*" data-hover="All">All</NavLink></li>
                                    {filters.map((item, index) => (
                                        <li key={index}><NavLink to={"#"} className="btn from-top" data-filter={item.filter} >{item.label}</NavLink></li>
                                    ))}
                                </ul>
                            </div>
                            
                            <ul className="masonry-outer mfp-gallery row work-grid clearfix list-unstyled">
                                {GalleryImages.map((item, index) => (
                                    <div key={index} className={`${item.filter} masonry-item col-xl-3  col-lg-4 col-md-6 col-sm-12`}>
                                        <div className="sx-box image-hover-block">
                                            <div className="sx-thum-bx">
                                                <img src={item.image} alt="" />
                                            </div>
                                            <div className="sx-info  p-t20 text-white">
                                                <h4 className="sx-tilte"><NavLink to={"/project-detail1"}>{item.title}</NavLink></h4>
                                                <p className="m-b0">{item.address}</p>
                                            </div>
                                            <a className="mfp-link" href={item.image}>
                                                <i className="fa fa-arrows-alt" />
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    };
};

export default Gallery;